export const ru = {
    'error-refresh': 'Возникла ошибка. Попробуйте обновить страницу.',
    'no-rights': 'Нет доступа для просмотра рекомендаций'
};
